import { jsx as _jsx } from "react/jsx-runtime";
import { getProductLabelSop } from '../../constants/productLabels';
export const GUIDE_PILLS = [
    { shortLabel: 'Get started', help: 'What you will do here' },
    { shortLabel: 'Use the extension', help: 'Capture from the browser' },
    { shortLabel: 'Record a flow', help: 'Capture with the browser extension' },
    { shortLabel: 'Library', help: 'Open Content Library from your dashboard' },
    { shortLabel: 'Content Library', help: 'Open flows and generate' },
    { shortLabel: 'Review Queue', help: 'Publish and review drafts' },
    { shortLabel: 'Templates', help: 'Pick or create a template' },
];
export function stripEmphasisForCoachmark(text) {
    return text.replace(/\*\*([^*]+)\*\*/g, '$1');
}
export function renderEmphasisText(text) {
    const segments = text.split(/(\*\*[^*]+\*\*)/g);
    return segments.map((seg, i) => {
        if (seg.startsWith('**') && seg.endsWith('**')) {
            return _jsx("strong", { children: seg.slice(2, -2) }, i);
        }
        return seg;
    });
}
/**
 * Pure copy for the welcome tour step card (no routing or DOM).
 * `extensionInstalled` may be null while the hook is still resolving.
 */
export function getWalkthroughStepPanel(step, extensionInstalled, templatesTourEnabled) {
    if (step === 0) {
        const trainingLabel = getProductLabelSop();
        return {
            kicker: 'Get started',
            title: `Turn browser work into ${trainingLabel}`,
            body: 'We highlight real controls and walk through your **Content Library** on the dashboard, the review queue, and Templates. Pick a topic to jump, or go in order with Next.',
            primaryLabel: 'Next: use the extension',
            showInstallSkip: false,
            coachmarkPlacement: 'bottom',
            coachKicker: 'Greeting',
        };
    }
    if (step === 1) {
        if (extensionInstalled) {
            return {
                kicker: 'Use the extension',
                title: 'You are set to record on this browser',
                body: 'We highlighted the **Install / Open** control. Pin the Cricket icon, switch to the tab you are capturing, then open the toolbar menu and tap **Start Recording**.',
                primaryLabel: 'Next: record a flow',
                showInstallSkip: false,
                coachmarkPlacement: 'bottom',
                coachKicker: 'Extension',
            };
        }
        return {
            kicker: 'Use the extension',
            title: 'Install the capture extension once',
            body: 'Recording runs in the browser. Use **Open installer** on the control we highlighted, then return here. Reopen the tour from Help any time.',
            primaryLabel: 'Open installer',
            showInstallSkip: true,
            coachmarkPlacement: 'bottom',
            coachKicker: 'Extension',
        };
    }
    if (step === 2) {
        return {
            kicker: 'Record a flow',
            title: 'Capture in the browser',
            body: 'Use **Open Extension** on your dashboard (highlighted) to open the capture toolbar, switch to the tab you want, then tap **Start Recording**. When you are done, return here and continue the tour.',
            primaryLabel: 'Next: try the Library',
            showInstallSkip: false,
            coachmarkPlacement: 'bottom',
            coachKicker: 'Recording',
        };
    }
    if (step === 3) {
        return {
            title: 'Open the Content Library from your dashboard',
            body: 'The **Open Library** button (highlighted) on your dashboard opens your flows in the app. Continue to jump straight into the library view with filters and the flow list.',
            primaryLabel: 'Continue to Library',
            showInstallSkip: false,
            coachmarkPlacement: 'bottom',
            coachKicker: 'Open Library',
        };
    }
    if (step === 4) {
        const trainingLabel = getProductLabelSop();
        return {
            kicker: 'Content Library',
            title: 'Generate from a flow',
            body: `Use filters to find a flow, then open it and run **Generate** to produce a draft ${trainingLabel}. Your draft opens in Review Studio.`,
            primaryLabel: 'Next: Review queue',
            showInstallSkip: false,
            coachmarkPlacement: 'top',
            coachKicker: 'Library',
        };
    }
    if (step === 5) {
        if (!templatesTourEnabled) {
            return {
                kicker: 'Review queue',
                title: 'Ready to publish',
                body: 'Move items through the queue: approve, request changes, or publish. Template management is limited to workspace admins—ask an admin when you need a new document shape.',
                primaryLabel: 'Finish tour',
                showInstallSkip: false,
                coachmarkPlacement: 'top',
                coachKicker: 'Reviews',
            };
        }
        return {
            kicker: 'Review queue',
            title: 'Ready to publish',
            body: `Move items through the queue: approve, request changes, or publish. This is the last check before the team sees the ${getProductLabelSop()} in production.`,
            primaryLabel: 'Next: Templates',
            showInstallSkip: false,
            coachmarkPlacement: 'top',
            coachKicker: 'Reviews',
        };
    }
    return {
        kicker: 'Templates',
        title: 'Reusable document shapes',
        body: 'Browse the gallery, duplicate a system template, or build your own so every generate run matches your org style.',
        primaryLabel: 'Finish tour',
        showInstallSkip: false,
        coachmarkPlacement: 'top',
        coachKicker: 'Templates',
    };
}
